import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { LocalStorageService } from 'src/app/services/local-storage/local-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { SignInJwtService } from 'src/app/services/signIn-jwt/signIn-jwt.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [fadeInUpAnimation]
})
export class LoginComponent implements OnInit {
  public formGroup: FormGroup<{ email: FormControl<string>; password: FormControl<string> }>;

  public inputType = 'password';
  public visible = false;
  public remember = false;

  constructor(
    private signInJwtService: SignInJwtService,
    private router: Router,
    private formBuild: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private localStorageService: LocalStorageService,
    private dialogRef: MatDialog
  ) {}

  public ngOnInit() {
    this.dialogRef.closeAll();

    this.formGroup = this.formBuild.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });

    if (this.localStorageService.getData('login')) {
      this.formGroup.controls.email.patchValue(this.localStorageService.getData('login') as string);
    }

    if (this.localStorageService.getData('password')) {
      this.formGroup.controls.password.patchValue(this.localStorageService.getData('password') as string);
    }

    const remimder = window.localStorage.getItem('pass_reminder');
    if (remimder == 'true') {
      this.remember = true;
    }
  }

  public send(): void {
    const loginString = String(this.formGroup.controls.email.value).toLowerCase();
    const loginPass = String(this.formGroup.controls.password.value);

    if (this.formGroup.valid) {
      this.signInJwtService.signInByLogin(loginString, loginPass).subscribe({
        complete: () => {
          this.saveRemenber(loginString, loginPass);
          this.gotToHome();
        },
        error: (error: string) => {
          console.warn(`Server error: ${error}`);
          this.displaySnackError(`Oups... Une erreur c'est produit.\nVérifiez vos informations.`);
        }
      });
    } else {
      this.displaySnackError('Informations incomplètes.');

      if (!this.formGroup.controls.email.valid) {
        this.formGroup.controls.email.markAsTouched();
      }

      if (!this.formGroup.controls.password.valid) {
        this.formGroup.controls.password.markAsTouched();
      }
    }
  }

  public setRemenber(event: MatCheckboxChange): void {
    this.remember = event.checked;
    localStorage.setItem('pass_reminder', String(this.remember));

    if (this.remember == false) {
      this.localStorageService.removeData('login');
      this.localStorageService.removeData('password');
    }
  }

  private displaySnackError(error: string): void {
    this.snackBar.open(error, '×', {
      panelClass: 'error',
      verticalPosition: 'top',
      duration: 3000
    });
  }

  public resetPassword(): void {
    void this.router.navigate(['lost-password']);
  }

  private gotToHome(): void {
    void this.router.navigate(['/']);
  }

  public toggleVisibility(): void {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.changeDetectorRef.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  private saveRemenber(login: string, password: string): void {
    if (this.remember === true) {
      this.localStorageService.saveData('login', login);
      this.localStorageService.saveData('password', password);
    }
  }
}
